import React from 'react';

/**
 * Full-screen "Under Maintenance" page shown on EVERY route while the
 * website-hero-setting's maintenanceMode flag is on. Rendered instead of
 * the router, so direct/shared links hit it too.
 */
const MaintenanceScreen: React.FC = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-gray-900 via-ocean-900 to-black text-white px-6">
    <img src="/logo.jpg" alt="PetroMarine" className="w-28 h-28 rounded-full object-cover shadow-2xl mb-8 border-4 border-white/10" />
    <h1 className="text-3xl md:text-4xl font-bold tracking-wide text-center">
      PetroMarine
    </h1>
    <p className="text-ocean-200 text-sm mt-1 tracking-widest uppercase">
      Offshore Projects Support Co.
    </p>

    <div className="w-16 h-px bg-ocean-400 my-8" />

    <h2 className="text-2xl md:text-3xl font-semibold text-center">
      Under Maintenance
    </h2>
    <p className="text-xl text-ocean-100 mt-3 text-center" dir="rtl">
      الموقع تحت الصيانة
    </p>
    <p className="mt-6 text-ocean-200 text-center max-w-md leading-relaxed">
      We're performing some updates to serve you better. Please check back soon.
    </p>
  </div>
);

export default MaintenanceScreen;
